<template>
  <section v-if="variant === variants.v1" class="pb-100" style="background: var(--isabelline)">
    <div class="container">
      <div class="tw-pb-16 tw-text-center">
        <h2 class="font-plus-jakarta-semibold tw-text-3xl lg:tw-text-4xl">
          {{ vars.titleText }}
        </h2>
      </div>
      <div class="tw-grid tw-grid-cols-1 tw-gap-20 tw-text-center lg:tw-grid-cols-3">
        <div
          v-for="(value, index) in values"
          :key="`value-${index}`"
          class="tw-flex tw-flex-col tw-items-center tw-gap-3"
        >
          <NuxtImg :src="value.photo" loading="lazy" :alt="value.title" quality="60" class="tw-h-32" />
          <h3 class="font-arial-bold tw-mb-2 tw-text-2xl">{{ value.title }}</h3>
          <p>{{ value.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <section v-if="variant === variants.v2" class="pb-100" :style="`background-color: var(${vars.backgroundColor})`">
    <div class="container">
      <div class="tw-pb-16 tw-pt-5 tw-text-center">
        <h3 class="">
          {{ vars.titleText }}
        </h3>
      </div>
      <div class="tw-grid tw-grid-cols-1 tw-gap-20 tw-text-center lg:tw-grid-cols-3">
        <div
          v-for="(value, index) in values"
          :key="`value-${index}`"
          class="tw-flex tw-flex-col tw-items-center tw-gap-3"
        >
          <NuxtImg :src="value.photo" loading="lazy" :alt="value.title" class="tw-h-32" />
          <h5 class="tw-mb-2">{{ value.title }}</h5>
          <p class="tw-text-left">{{ value.description }}</p>
        </div>
      </div>
    </div>
  </section>

   <section v-if="variant === variants.v3" class="pb-100" :style="`background-color: var(${vars.backgroundColor})`">
    <div class="container">
      <div class="tw-pb-16 tw-pt-5 tw-text-center">
        <h3 class="">
          {{ vars.titleText }}
        </h3>
      </div>
      <div class="tw-grid tw-grid-cols-1 tw-gap-20 tw-text-center lg:tw-grid-cols-3">
        <div
          v-for="(value, index) in values"
          :key="`value-${index}`"
          class="tw-flex tw-flex-col tw-items-center tw-gap-3"
        >
          <NuxtImg :src="value.photo" loading="lazy" :alt="value.title" class="tw-h-32 tw-mb-3" />
          <h5 class="tw-mb-2">{{ value.title }}</h5>
          <p>{{ value.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'OurValues',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },

  computed: {
    values() {
      return this.groupedVariables.values;
    },
  },
});
</script>
